(function() {
  document.addEventListener("DOMContentLoaded", function() {
    const readMoreBtns = document.querySelectorAll('.read-more__btn');
    const readLessBtns = document.querySelectorAll('.read-less__btn');
    const productDescriptions = document.querySelectorAll('.product__description');

    if (readMoreBtns.length > 0 && productDescriptions.length > 0 && readLessBtns.length > 0) {
      readMoreBtns.forEach((readMoreBtn, index) => {
        const productDescription = productDescriptions[index];
        const readLessBtn = readLessBtns[index];

        readMoreBtn.addEventListener('click', () => {
          productDescription.classList.remove('gradient__effect');
          // productDescription.innerHTML = productDescription.getAttribute('data-desc');
          readMoreBtn.classList.add('hidden');
          readLessBtn.classList.remove('hidden');
        });

        readLessBtn.addEventListener('click', () => {
          productDescription.classList.add('gradient__effect');
          // productDescription.innerHTML = productDescription.getAttribute('data-desc-less');
          readMoreBtn.classList.remove('hidden');
          readLessBtn.classList.add('hidden');
        });
      });
    }
  });
})();
